import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { filter, size, map } from 'lodash';

import RoomsTableRowRender from './RoomsTableRowRender';
import { getActiveRoomsCount, isRoomSpeedInFilter } from '../../../../../../utils/roomUtils';


const RoomsTableMobileRender = React.memo(({
  tooltipId, friends, roomsProps, joinedRoom, uid, leaveRoom, activeTournament, finishedTournamentLastRound, popoverOpen, joinRoomClicked, onHover, onHoverLeave, joinRoomClickedFunc, joinPrivateRoomConfirm, screenMode, filters, t
}) => {
  // const rooms = {};

  let filteredRooms = { ...roomsProps };
  const friendsIds = size(friends) > 0 ? map(friends, (item, key) => { return size(item) > 0 ? item.uid : null; }) : [];

  console.log(filteredRooms, friends, friendsIds, "filteredRooms");

  if (filters && filters?.gameType && size(filters?.gameType) > 0) {
    filteredRooms = filter(filteredRooms, (item, key) => { return item.globalParams?.gameType?.includes(filters?.gameType); })
  }

  /*
  if (filters?.fourPRoom && filters?.fourPRoom[0] === true) {
    filteredRooms = filter(filteredRooms, (item, key) => { return item.globalParams?.fourPRoom === true; })
  } else if (filters?.fourPRoom && filters?.fourPRoom[0] === false) {
    filteredRooms = filter(filteredRooms, (item, key) => { return !item.globalParams?.fourPRoom })
  } */

  if (filters?.fourPRoom && (filters?.fourPRoom.length && !filters?.fourPRoom.includes(4))) {
  //  console.log('check for 4 player rooms', filters?.fourPRoom);
    filteredRooms = filter(filteredRooms, (item, key) => { return !item.globalParams?.fourPRoom; })
  }
  if (filters?.fourPRoom && (filters?.fourPRoom.length && !filters?.fourPRoom.includes(3))) {
  //  console.log('check for 3 player rooms', filters?.fourPRoom);
    filteredRooms = filter(filteredRooms, (item, key) => { return (item.globalParams?.fourPRoom || item.globalParams?.studentRoom) })
  }
  if (filters?.fourPRoom && (filters?.fourPRoom.length && !filters?.fourPRoom.includes(2))) {
  //  console.log('check for student rooms', filters?.fourPRoom);
    filteredRooms = filter(filteredRooms, (item, key) => { return !item.globalParams?.studentRoom; })
  }

  if (filters?.minGames && size(filters?.minGames) > 0) {
    filteredRooms = filter(filteredRooms, (item, key) => { return filters?.minGames.includes(item.globalParams?.minGames); })
  }
  if (filters?.bet && size(filters?.bet) > 0) {
    filteredRooms = filter(filteredRooms, (item, key) => { return filters?.bet.includes(item.globalParams?.bet); })
  }
  if (filters?.speed && size(filters?.speed) > 0) {
    filteredRooms = filter(filteredRooms, (item, key) => { return isRoomSpeedInFilter(item, filters?.speed) })
  }
  if (filters?.maza) {
    filteredRooms = filter(filteredRooms, (item, key) => { return item.globalParams?.smallGame; })
  }
  if (filters?.privateRoom) {
    filteredRooms = filter(filteredRooms, (item, key) => { return item.globalParams?.privateRoom; })
  }
  if (filters?.pro) {
    filteredRooms = filter(filteredRooms, (item, key) => { return item.globalParams?.proGame; })
  }

  if (joinedRoom && joinedRoom.key && joinedRoom.globalParams && joinedRoom.playersList) {
    filteredRooms = filter(filteredRooms, (item, key) => { return item.key !== joinedRoom.key; })
  }

  if (filters?.friendsRoom && size(friendsIds) > 0) {
    filteredRooms = filter(filteredRooms, (item, key) => {
      if (item?.playersList) {
        return (item.playersList.player1 && friendsIds.includes(item.playersList?.player1?.uid)) || (item.playersList.player2 && friendsIds.includes(item.playersList.player2.uid)) || (item.playersList.player3 && friendsIds.includes(item.playersList.player3.uid)) || (item.playersList.player4 && friendsIds.includes(item.playersList.player4.uid));
      }
    });
  }

  // console.log('filteredRooms', filteredRooms, roomsProps);

  if (getActiveRoomsCount(filteredRooms) > 0) {
    const filteredVipRooms = filter(filteredRooms, (item) => { return item.globalParams?.vipRoom; });
    const filteredRooms2 = filter(filteredRooms, (item) => { return !item.globalParams?.vipRoom; });

    return (
      <Fragment>
        {filteredVipRooms.sort((a, b) => {
          if (a.key < b.key) { return -1; }
          if (a.key > b.key) { return 1; }
          return 0;
        }).map(item => {
          return (
            <RoomsTableRowRender
              key={item.key}
              room={item}
              removal={item.removal}
              joinedRoom={joinedRoom}
              uid={uid}
              leaveRoom={leaveRoom}
              activeTournament={activeTournament}
              finishedTournamentLastRound={finishedTournamentLastRound}
              popoverOpen={popoverOpen}
              joinRoomClicked={joinRoomClicked}
              onHover={onHover}
              onHoverLeave={onHoverLeave}
              joinRoomClickedFunc={joinRoomClickedFunc}
              joinPrivateRoomConfirm={joinPrivateRoomConfirm}
              screenMode={screenMode}
              tooltipId={tooltipId}
            />
          );
        })}

        {filteredRooms2.sort((a, b) => {
          if (a.key < b.key) { return -1; }
          if (a.key > b.key) { return 1; }
          return 0;
        }).map(item => {
          return (
            <RoomsTableRowRender
              key={item.key}
              room={item}
              removal={item.removal}
              joinedRoom={joinedRoom}
              uid={uid}
              leaveRoom={leaveRoom}
              activeTournament={activeTournament}
              finishedTournamentLastRound={finishedTournamentLastRound}
              popoverOpen={popoverOpen}
              joinRoomClicked={joinRoomClicked}
              onHover={onHover}
              onHoverLeave={onHoverLeave}
              joinRoomClickedFunc={joinRoomClickedFunc}
              joinPrivateRoomConfirm={joinPrivateRoomConfirm}
              screenMode={screenMode}
              tooltipId={tooltipId}
            />
          );
        })}
        {/* {map(filteredRooms, (item, key) => {
          if (!item.key || joinedRoom && joinedRoom.key && joinedRoom.globalParams && joinedRoom.playersList && item.key === joinedRoom.key) {
            return null;
          }
          return (
            <RoomsTableRowRender
              key={item.key}
              room={item}
              removal={item.removal}
              joinedRoom={joinedRoom}
              uid={uid}
              leaveRoom={leaveRoom}
              activeTournament={activeTournament}
              popoverOpen={popoverOpen}
              joinRoomClicked={joinRoomClicked}
              onHover={onHover}
              onHoverLeave={onHoverLeave}
              joinRoomClickedFunc={joinRoomClickedFunc}
              joinPrivateRoomConfirm={joinPrivateRoomConfirm}
              screenMode={screenMode}
              tooltipId={tooltipId}
            />
          );
        })} */}
      </Fragment>
    );
  }
  return (<div className="d-flex align-items-center h-100 rooms-table-empty-entries">{t('roomsTable.roomsTableEmptyEntries')}</div>);
});

RoomsTableMobileRender.propTypes = {
  joinedRoom: PropTypes.shape(),
  uid: PropTypes.string,
  leaveRoom: PropTypes.func.isRequired,
  activeTournament: PropTypes.string,
  popoverOpen: PropTypes.shape(),
  joinRoomClicked: PropTypes.bool,
  onHover: PropTypes.func.isRequired,
  onHoverLeave: PropTypes.func.isRequired,
  joinRoomClickedFunc: PropTypes.func.isRequired,
  joinPrivateRoomConfirm: PropTypes.func.isRequired,
  filters: PropTypes.shape(),
  tooltipId: PropTypes.string,
  roomsProps: PropTypes.shape(),
};

RoomsTableMobileRender.defaultProps = {
  joinedRoom: null,
  uid: null,
  activeTournament: null,
  popoverOpen: {},
  joinRoomClicked: false,
  roomsProps: {},
  filters: {
    speed: [],
    bet: [],
    minGames: [],
    fourPRoom: [],
    gameType: [],
    maza: false,
    privateRoom: false,
    pro: false,
    tooltipId: null,
  },
};

export default RoomsTableMobileRender;
